import React, { useEffect, useRef } from 'react';
import { ArrowRight, Calendar } from 'lucide-react';
import './Hero.css';

/* ═══════════════════════════════════════════
   HERO
═══════════════════════════════════════════ */
export default function Hero() {
  const heroRef = useRef(null);

  /* scroll-linked exit — mirrors the entrance: zooms up + blurs out
     as the hero scrolls out of view */
  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;

    let raf = null;
    const handleScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const scrolledPast = Math.max(0, -rect.top);
        const progress = Math.min(1, scrolledPast / (rect.height * 0.65));
        el.style.setProperty('--exit', progress.toFixed(3));
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section className="hero" id="home" ref={heroRef}>
      {/* ambient bg */}
      <div className="hero-bg">
        <div className="hero-ignite" />
        <div className="hero-orb hero-orb-1" />
        <div className="hero-orb hero-orb-2" />
        <div className="hero-particles">
          {Array.from({ length: 14 }).map((_, i) => (
            <span key={i} className={`hero-particle hp-${i % 7}`} />
          ))}
        </div>
      </div>

      <div className="hero-inner">
        <div className="hero-copy">
          <div className="hero-badge reveal-up" style={{ '--d': '0ms' }}>
            <span className="badge-dot" />
            Available for new projects
          </div>

          <h1 className="hero-title">
            <span className="line-mask">
              <span className="line-inner" style={{ '--d': '260ms' }}>
                Building Digital Solutions
              </span>
            </span>
            <span className="line-mask">
              <span className="line-inner" style={{ '--d': '480ms' }}>
                at <span className="gradient-text">Maxwell Tech.</span>
              </span>
            </span>
          </h1>

          <p className="hero-subtitle reveal-up" style={{ '--d': '900ms' }}>
            We are a freelance team specializing in web development, software solutions,
            UI/UX design, and digital innovation.
          </p>

          <div className="hero-actions reveal-pop" style={{ '--d': '1250ms' }}>
            <a href="#contact" className="btn-primary">
              <span className="btn-primary-shine" />
              <span className="btn-primary-label">Start a Project <ArrowRight size={16} /></span>
            </a>
            <a href="#services" className="btn-ghost">
              <Calendar size={16} />
              Book a Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}